import { CommercialPackagesModel } from 'library/src/commercialPackages/models/CommercialPackagesModel';
import { sharedCommonActions } from 'library/src/common/redux/SharedCommonActions';
import { getErrorMessage, logger } from 'library/src/core/services/LogService';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import pixagriCommercialPackagesApiService from '../services/PixagriCommercialPackagesApiService';
import {
    GET_COMMERCIAL_PACKAGES,
    sharedCommercialPackagesActions,
} from './SharedCommercialPackagesActions';

export default function* sharedCommercialPackageSagas() {
  yield all([takeEvery(GET_COMMERCIAL_PACKAGES, getCommercialPackagesSaga)]);
}

function* getCommercialPackagesSaga() {
  try {
    yield put(sharedCommonActions.fetchStart('getCommercialPackagesSaga'));
    const commercialPackages: CommercialPackagesModel[] = yield call(
      pixagriCommercialPackagesApiService.getCommercialPackages.bind(
        pixagriCommercialPackagesApiService,
      ),
    );
    yield put(
      sharedCommercialPackagesActions.getCommercialPackagesSuccess(
        commercialPackages,
      ),
    );
    yield put(sharedCommonActions.fetchSuccess('getCommercialPackagesSaga'));
  } catch (error) {
    const message = getErrorMessage(error);
    logger.error(message);
    yield put(
      sharedCommonActions.fetchError('getCommercialPackagesSaga', message),
    );
  }
}
